import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ResponseMessageType } from "~/domains";

type RequestDataType = {
  documentFileId: string;
};

const request = ({ documentFileId }: RequestDataType) => {
  return new ApiClient()
    .post<ResponseMessageType>(
      `/api/members/document_files/${documentFileId}/previews`,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersDocumentFilesPreviewsCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<ResponseMessageType, RequestDataType> => {
  return useMutation(request, { ...options });
};
